"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotionBlocksHtmlParser = exports.defaultMarkedOptions = void 0;
const blocks_markdown_parser_1 = require("@notion-stuff/blocks-markdown-parser");
exports.defaultMarkedOptions = {
    pedantic: false,
    gfm: true,
    breaks: false,
    sanitize: false,
    smartLists: true,
    smartypants: false,
    xhtml: false,
};
let marked, hljs, prism;
class NotionBlocksHtmlParser {
    constructor(parserOptions = {}) {
        this.parserOptions = NotionBlocksHtmlParser.assignDefaultOptions(parserOptions);
    }
    static getInstance(parserOptions = {}) {
        if (!this.instance) {
            this.instance = new this(parserOptions);
            if (typeof this.instance.parserOptions.mdToHtmlOptions === 'object') {
                this.setupMarked(this.instance.parserOptions);
            }
        }
        if (!this.markdownParser) {
            this.markdownParser = blocks_markdown_parser_1.NotionBlocksMarkdownParser.getInstance(this.instance.parserOptions.mdParserOptions);
        }
        return this.instance;
    }
    static getMarkdownParser() {
        if (!this.markdownParser) {
            throw new Error('MarkdownParser is not available until HtmlParser instance has been created');
        }
        return this.markdownParser;
    }
    parse(blocks) {
        const markdown = NotionBlocksHtmlParser.markdownParser.parse(blocks);
        const { mdToHtmlOptions } = this.parserOptions;
        if (typeof mdToHtmlOptions === 'object') {
            return marked(markdown, mdToHtmlOptions);
        }
        return mdToHtmlOptions(markdown, this.parserOptions);
    }
    static assignDefaultOptions(parserOptions) {
        return Object.assign({ mdParserOptions: {}, mdHighlightingOptions: 'hljs', mdToHtmlOptions: exports.defaultMarkedOptions }, parserOptions);
    }
    static setupMarked({ mdToHtmlOptions, mdHighlightingOptions, }) {
        try {
            // eslint-disable-next-line @typescript-eslint/no-var-requires
            const _marked = require('marked');
            marked = _marked.marked || _marked;
        }
        catch (e) {
            const message = `Error importing package: marked. Please install "marked" package.`;
            console.error(message);
            throw new Error(message);
        }
        const renderer = new marked.Renderer();
        const codeTransformer = (code, language) => {
            const langClass = 'language-' +
                (!language || language.includes('plain') ? 'none' : language);
            if (mdHighlightingOptions === 'hljs') {
                return `<pre><code class='hljs ${langClass}'>${code.value}</code></pre>`;
            }
            // prism
            if (!language) {
                return `<pre><code>${code}</code></pre>`;
            }
            // e.g. "language-js"
            return `<pre class='${langClass}'><code class='${langClass}'>${code}</code></pre>`;
        };
        renderer.code = function (code, language) {
            code = this.options.highlight(code, language);
            return codeTransformer(code, code.language || language);
        };
        renderer.html = function (mixedHtml) {
            return mixedHtml.replace(/[^<>]+?(?=<\/[figcaption|span])/g, (match) => {
                const tokens = marked.lexer(match);
                return marked.parser(tokens);
            });
        };
        mdToHtmlOptions.renderer = renderer;
        if (!mdToHtmlOptions.highlight) {
            if (mdHighlightingOptions === 'hljs') {
                if (!hljs) {
                    try {
                        hljs = require('highlight.js');
                    }
                    catch (e) {
                        const message = `Error importing package: highlight.js. Please install "highlight.js" package.`;
                        console.error(message);
                        throw new Error(message);
                    }
                }
                mdToHtmlOptions.highlight = (code, lang) => {
                    const language = hljs.getLanguage(lang) ? lang : 'plaintext';
                    return hljs.highlight(code, { language });
                };
            }
            else if (mdHighlightingOptions === 'prismjs') {
                if (!prism) {
                    try {
                        prism = require('prismjs');
                        require('prismjs/components/prism-bash');
                        require('prismjs/components/prism-css');
                        require('prismjs/components/prism-javascript');
                        require('prismjs/components/prism-json');
                        require('prismjs/components/prism-markup');
                        require('prismjs/components/prism-markdown');
                        require('prismjs/components/prism-typescript');
                        require('prismjs/components/prism-jsx');
                        require('prismjs/components/prism-tsx');
                        require('prismjs/components/prism-docker');
                    }
                    catch (e) {
                        const message = `Error importing package: prismjs. Please install "prismjs" package.`;
                        console.error(message);
                        throw new Error(message);
                    }
                }
                mdToHtmlOptions.highlight = (code, lang) => {
                    if (!prism.languages[lang]) {
                        return code;
                    }
                    return prism.highlight(code, prism.languages[lang]);
                };
            }
            else {
                mdToHtmlOptions.highlight =
                    mdHighlightingOptions;
            }
        }
    }
}
exports.NotionBlocksHtmlParser = NotionBlocksHtmlParser;
//# sourceMappingURL=blocks-html-parser.js.map